import { Link } from "react-router-dom";
import { Phone, Camera } from "lucide-react";
import { Eyebrow } from "@/components/ui-custom/Eyebrow";
import { Reveal } from "@/components/ui-custom/Reveal";
import { SITE } from "@/data/site";

export const PreFooterCTA = () => {
  return (
    <section className="sec-black section-y relative overflow-hidden" data-testid="prefooter-cta">
      {/* background image placeholder */}
      <div className="absolute inset-0" style={{ background: "var(--charcoal)" }} />
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(60% 80% at 80% 20%, rgba(245,207,112,0.12) 0%, rgba(0,0,0,0) 55%), repeating-linear-gradient(45deg, rgba(255,255,255,0.012) 0px, rgba(255,255,255,0.012) 1px, transparent 1px, transparent 10px)",
        }}
      />
      <div className="absolute inset-0 flex items-center justify-center opacity-[0.05]">
        <Camera size={200} strokeWidth={1} style={{ color: "var(--cta)" }} />
      </div>
      <div className="absolute inset-0" style={{ background: "linear-gradient(rgba(13,13,15,0.72), rgba(13,13,15,0.86))" }} />

      <div className="container-1200 text-center relative z-10">
        <Reveal>
          <Eyebrow className="mx-auto">No Surprises</Eyebrow>
          <h2 className="h2 mt-6" style={{ color: "var(--text-light)" }}>Get Your Free Estimate</h2>
          <p className="mt-4" style={{ color: "rgba(245,242,236,0.78)", fontSize: "18px" }}>
            Honest pricing. No surprises. On schedule.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-9">
            <Link to="/contact#quote" className="btn btn-primary" data-testid="cta-request-quote">Request a Quote</Link>
            <a href={SITE.phoneHref} className="btn btn-secondary" data-testid="cta-phone">
              <Phone size={17} strokeWidth={1.75} />
              {SITE.phone}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
